import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_EMPLOYEE_ABSENCES } from './get-current-absences.hook';

export const CREATE_EMPLOYEE_ABSENCE = gql`
  mutation createMemberAbsence($payload: CreateMemberAbsenceInput!) {
    createMemberAbsence(payload: $payload) {
      _id
    }
  }
`;

export const useCreateEmployeeAbsence = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [createEmployeeAbsence] = useMutation(CREATE_EMPLOYEE_ABSENCE, {
    refetchQueries: [GET_CURRENT_EMPLOYEE_ABSENCES],
    onCompleted: onSuccess,
  });

  return createEmployeeAbsence;
};
